import React, { Component } from "react";
import { resetPassword } from "../../common/helpers/auth";
//PrimeReact Components
import * as pr from "../../common/PrimeComponents";

class Password extends Component {
  state = { loading: false, email: "" };

  handleSubmitPassword = () => {
    this.setState({ loading: true });

    resetPassword(this.state.email)
      .then(() => {
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "Password reset email sent",
          life: 3000
        });
      })
      .catch(err => {
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: err.message,
          life: 3000
        });
      });

    this.setState({ loading: false });
  };

  handleKeyPress = e => {
    if (e.key === "Enter") {
      this.handleSubmitPassword();
    }
  };

  render() {
    return (
      <div className="login-page" onKeyPress={this.handleKeyPress}>
        <pr.Growl style={{ textAlign: "left" }} ref={el => (this.growl = el)} />
        <div className="ui-g">
          <div className="card login-panel ui-fluid">
            <div className="ui-g">
              <div className="ui-g-12" style={{ padding: "20px 40px" }}>
                <img
                  src="/assets/layout/images/bpp/bpp-logo.png"
                  alt=""
                  height="100%"
                  width="100%"
                />
              </div>
              <div className="ui-g-12" style={{ padding: "20px 40px" }}>
                <span className="md-inputfield form-field">
                  <pr.InputText
                    value={this.state.email || ""}
                    onChange={e => {
                      this.setState({
                        email: e.target.value
                      });
                    }}
                  />
                  <label>Email Address</label>
                </span>
              </div>
              <div className="ui-g-12" style={{ padding: "20px 40px" }}>
                <pr.Button
                  label="Reset Password"
                  icon={
                    this.state.loading
                      ? "pi pi-spin pi-spinner"
                      : "pi pi-replay"
                  }
                  onClick={() => {
                    this.handleSubmitPassword();
                  }}
                />
                <span className="ui-float-label">
                  <a href="#/">Sign In?</a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Password;



// WEBPACK FOOTER //
// ./src/components/Password/Password.js